module.exports = __webpack_public_path__ + "static/media/spamtp.7c856901.png";